import React from "react";
import { useT } from "@/lib/i18n";
import { Construction } from "lucide-react";

export default function Placeholder({ titleKey, icon: Icon }) {
  const { t } = useT();
  return (
    <div className="mx-auto max-w-[1400px] p-4 sm:p-6 lg:p-8">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{t(titleKey)}</h1>
      <div className="mt-8 flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white py-24 text-center" data-testid="placeholder-empty-state">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-50 text-primary">
          {Icon ? <Icon className="h-7 w-7" /> : <Construction className="h-7 w-7" />}
        </div>
        <h2 className="mt-5 text-lg font-semibold text-slate-900">Module en préparation</h2>
        <p className="mt-1.5 max-w-sm text-sm text-slate-500">
          Ce module fait partie de la feuille de route. La fondation (architecture, rôles, données) est déjà prête pour l'accueillir.
        </p>
      </div>
    </div>
  );
}
